export const DAY_OF_WEEK = {
  SUNDAY: 0,
  MONDAY: 1,
  TUESDAY: 2,
  WEDNESDAY: 3,
  THURSDAY: 4,
  FRIDAY: 5,
  SATURDAY: 6,
} as const;

export type DayOfWeek = typeof DAY_OF_WEEK[keyof typeof DAY_OF_WEEK];


export const PAYMENT_FREQUENCIES = {
  ONE_TIME: 0,
  WEEKLY: 10,
  TWICE_A_MONTH: 20,
  MONTHLY: 30,
  QUARTERLY: 40,
  CUSTOM: 50,
} as const;
type PaymentFrequency = typeof PAYMENT_FREQUENCIES[keyof typeof PAYMENT_FREQUENCIES];

export const frequencyMapping: Record<PaymentFrequency, string> = {
  [PAYMENT_FREQUENCIES.ONE_TIME]: 'oneTime',
  [PAYMENT_FREQUENCIES.WEEKLY]: 'weekly',
  [PAYMENT_FREQUENCIES.TWICE_A_MONTH]: 'twiceAMonth',
  [PAYMENT_FREQUENCIES.MONTHLY]: 'monthly',
  [PAYMENT_FREQUENCIES.QUARTERLY]: 'quarterly',
  [PAYMENT_FREQUENCIES.CUSTOM]: 'custom',
};

export const SEMIMONTHLY_OPTIONS = {
  FIRST_AND_FIFTEENTH: 0,
  FIFTEENTH_AND_LAST: 10,
} as const;
export type SemiMonthlyOption = typeof SEMIMONTHLY_OPTIONS[keyof typeof SEMIMONTHLY_OPTIONS];

export const semiMonthlyOptionMapping: Record<SemiMonthlyOption, string> = {
  [SEMIMONTHLY_OPTIONS.FIRST_AND_FIFTEENTH]: 'firstAndFifteenth',
  [SEMIMONTHLY_OPTIONS.FIFTEENTH_AND_LAST]: 'fifteenthAndLast',
};

export type PaymentScheduleModel = {
  frequency: PaymentFrequency;
  startDate: Date;
  endDate: Date;
} & (
      | {
        frequency: typeof PAYMENT_FREQUENCIES.ONE_TIME;
      }
    | {
      frequency: typeof PAYMENT_FREQUENCIES.CUSTOM;
      customDates: string[];
    }
    | {
      frequency: typeof PAYMENT_FREQUENCIES.WEEKLY;
      dayOfWeek: DayOfWeek;
    }
    | {
      frequency: typeof PAYMENT_FREQUENCIES.MONTHLY;
    }
    | {
      frequency: typeof PAYMENT_FREQUENCIES.TWICE_A_MONTH;
      semiMonthlyOption: SemiMonthlyOption;
    }
    | {
      frequency: typeof PAYMENT_FREQUENCIES.QUARTERLY;
    }
);

export type PaymentScheduleExport = string[];
